
<div class="main_run_hold" #scrollBottom>
  <app-in-progress-process *ngIf="appp=='anc'"></app-in-progress-process>

  <h3 class="head_forProcesStart">Start New Process</h3>
  <div class="partion_container">
    <div class="spinner" *ngIf="false">
      <div class="spin_div" *ngIf="disable">
        <div class="spana">
          <mat-spinner></mat-spinner>
        </div>
        <div class="text_por">Processing Clients....</div>
        <!--<div class="text_por">{{percent}}</div>-->
        <div class="text_por">
          <mat-progress-bar mode="determinate" [value]="percent"></mat-progress-bar>
        </div>

        <div class="text_por">{{currentProcessing}}</div>
      </div>

    </div>
    <div class="parti_cl parti_par">
      <h3>All Clients</h3>
      <ul class="parti_ul">
        <li class="parti_li" *ngFor="let cl of clients">
          <span class="parti_span">
            <div class="texter">
              {{cl.name}}
            </div>
            <span class="cross" (click)="add(cl)">+</span>

          </span>
        </li>

      </ul>
    </div>

    <div class="btn_proces_holder">
      <button mat-raised-button color="accent" (click)="processSelected()"
              [disabled]="selectedClie.length==0 || disable">
        Process
      </button>

      <!--<button mat-raised-button color="accent" (click)="open_res()"
              >
        Dummy
      </button>-->
    </div>


    <div class="parti_selected parti_par">
      <h3>Selected Clients</h3>
      <ul class="parti_ul">
        <li class="parti_li" *ngFor="let cl of selectedClie">
          <span class="parti_span">
            <div class="texter">
              {{cl.name}}
            </div>
            <span class="cross" (click)="rem(cl)">X</span>
          </span>
        </li>
      </ul>
    </div>

  </div>
  <!--*ngIf="resultData.length>0"-->
  <div id="bott">
    <app-process-result [inprogress]="disable" *ngIf="resultData.length>0" [result]="resultData" [appName]="appp" (clearParentList)="clearList($event)"></app-process-result>
  </div>

</div>
